import { call, put, takeLatest } from 'redux-saga/effects';

import { HealthQuoteApi } from '@apis/HealthQuoteApi';
import { HealthQuote } from '@models/HealthQuote';
import { SagaPayload } from '@utils/typescript';

import {
  healthQuoteFind,
  HealthQuoteFindPayload,
  healthQuoteSendEmail,
  HealthQuoteSendEmailPayload,
  stateUpdate,
  StateUpdatePayload
} from './action';

function* handleHealthQuoteFind({ payload }: SagaPayload<HealthQuoteFindPayload>) {
  const state: StateUpdatePayload = { healthQuote: null };
  try {
    state.healthQuote = (yield call(HealthQuoteApi.find, payload)) as HealthQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthQuoteSendEmail({ payload }: SagaPayload<HealthQuoteSendEmailPayload>) {
  yield call(HealthQuoteApi.sendEmail, payload);
}

export default function* () {
  yield takeLatest(healthQuoteFind, handleHealthQuoteFind);
  yield takeLatest(healthQuoteSendEmail, handleHealthQuoteSendEmail);
}
